export const IMAGE_IN_TOP = 'IMAGE_IN_TOP';
export const IMAGE_IN_RIGHT = 'IMAGE_IN_RIGHT';
export const BIG_TEXT = 'BIG_TEXT';
export const SMALL_TEXT = 'SMALL_TEXT';
